import SuperbadgeContentList from "th/superbadgeContentList";

export { SuperbadgeContentList };

customElements.define(
  "th-superbadge-content-list",
  SuperbadgeContentList.CustomElementConstructor
);
